var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineSeparatorRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 6,
    viewBox: "0 0 229 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, " -->\n", /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 6,
    viewBox: "0 0 229 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.866667 3C0.866667 4.17821 1.82179 5.13333 3 5.13333C4.17821 5.13333 5.13333 4.17821 5.13333 3C5.13333 1.82179 4.17821 0.866667 3 0.866667C1.82179 0.866667 0.866667 1.82179 0.866667 3ZM228.283 3.28284C228.439 3.12663 228.439 2.87337 228.283 2.71716L225.737 0.171573C225.581 0.0153632 225.328 0.0153632 225.172 0.171573C225.015 0.327783 225.015 0.581048 225.172 0.737258L227.434 3L225.172 5.26274C225.015 5.41895 225.015 5.67222 225.172 5.82843C225.328 5.98464 225.581 5.98464 225.737 5.82843L228.283 3.28284ZM3 3V3.4H228V3V2.6H3V3Z",
    fill: "#141743"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineSeparatorRight);
export default __webpack_public_path__ + "static/media/timeline-separator-right.847385a5e17a061f312fe9152ac21ba3.svg";
export { ForwardRef as ReactComponent };